export default __webpack_public_path__ + "static/media/icon_popup_comentario_add.b35d4479.svg";